import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const TechStack = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const techCategories = [
    {
      title: t.techStack.categories.data,
      techs: [
        { name: 'Power BI', level: 95 },
        { name: 'PostgreSQL', level: 90 },
        { name: 'Apache Airflow', level: 85 },
        { name: 'Metabase', level: 88 },
        { name: 'Excel/VBA', level: 92 }
      ]
    },
    {
      title: t.techStack.categories.web,
      techs: [
        { name: 'React', level: 88 },
        { name: 'JavaScript', level: 90 },
        { name: 'Python/FastAPI', level: 85 },
        { name: 'HTML/CSS', level: 92 },
        { name: 'Typo3', level: 80 }
      ]
    },
    {
      title: t.techStack.categories.database,
      techs: [
        { name: 'SQL', level: 95 },
        { name: 'Data Warehouse', level: 88 },
        { name: 'MongoDB', level: 75 },
        { name: 'Database Design', level: 90 }
      ]
    },
    {
      title: t.techStack.categories.languages,
      techs: [
        { name: 'Python', level: 88 },
        { name: 'JavaScript', level: 90 },
        { name: 'Java', level: 75 },
        { name: 'Visual Basic', level: 80 }
      ]
    }
  ];

  return (
    <section id="skills" className="brutalist-section">
      <div className="brutalist-container">
        <div data-reveal="out" className="grid md:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div>
            <p className="brutalist-kicker">{t.techStack.title}</p>
            <h2 className="brutalist-title mt-4">{t.techStack.subtitle}</h2>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {techCategories.map((category, index) => (
              <div
                key={index}
                data-reveal="out"
                style={{ '--reveal-delay': `${index * 70}ms` }}
                className="brutalist-card p-6 transition-colors duration-100 ease-linear hover:bg-muted hover:border-accent"
              >
                <h3 className="font-mono tracking-[0.08em] text-lg font-semibold">
                  {category.title}
                </h3>

                <div className="mt-6 space-y-4">
                  {category.techs.map((tech, idx) => (
                    <div key={idx}>
                      <div className="flex items-center justify-between gap-4">
                        <span className="font-medium">{tech.name}</span>
                        <span className="font-mono text-xs tracking-[0.18em] text-muted-foreground">{tech.level}%</span>
                      </div>
                      <div className="mt-2 h-2 bg-border overflow-hidden">
                        <div
                          className="skill-bar"
                          style={{
                            width: `${tech.level}%`,
                            '--bar-delay': `${idx * 80}ms`
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div data-reveal="out" style={{ '--reveal-delay': '80ms' }} className="mt-12 border-t border-border pt-10">
          <h3 className="text-center font-mono tracking-[0.18em] text-sm font-semibold">
            {language === 'de' ? 'Weitere Tools & Technologien' : 'Additional Tools & Technologies'}
          </h3>
          <div className="mt-6 flex flex-wrap justify-center gap-2">
            {['Git', 'Docker', 'Linux', 'SAP CO', 'Business Objects', 'REST APIs', 'Node.js', 'Tailwind CSS'].map((tool, idx) => (
              <span
                key={idx}
                className="font-mono text-xs tracking-[0.14em] border border-border px-3 py-2"
              >
                {tool}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
